export default {
   user: null,
   actor: null,
   access_token: null,
   is_logged: false,
   logged_at: null,
 }